var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeopen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 225.88C208.56 225.88 0 512 0 512s208.56 286.12 512 286.12S1024 512 1024 512 815.44 225.88 512 225.88zm0 451.77a180.71 180.71 0 01-180.71-180.71c0-99.8 80.91-180.7 180.71-180.7s180.71 80.9 180.71 180.7A180.71 180.71 0 01512 677.65z",
    fillRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 496.94,
    r: 116.89,
    transform: "rotate(-9.22 511.849 496.817)"
  })));
}
export default SvgEyeopen;